import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useQuery } from '@apollo/client';

import { ButtonModel, ModalContext } from '@notino/react-styleguide';
import { trackEvent } from '@notino/web-tracking';

import { MY_NOTINO_BENEFIT_PAGE } from '../../constants';
import { getCustomerBenefits } from '../../queries/__generated__/getCustomerBenefits';
import getCustomerBenefitsQuery from '../../queries/getCustomerBenefits.graphql';
import { LoyaltyStatus, trackLoyaltyModal } from '../../trackLoyaltyModal';
import { BaseLoyaltyModal } from '../BaseLoyaltyModal';
import { StyledButton } from '../styled';

import { BenefitsModalTable } from './BenefitsModalTable';
import { benefitsModalTableMessages } from './BenefitsModalTable/messages';
import { benefitsModalMessages } from './messages';
import {
  BenefitsModalContentWrapper,
  ButtonWrapper,
  SettingsWrapper,
} from './styled';

export const BenefitsModal: React.FC = () => {
  const { formatMessage } = useIntl();

  const { hideModal } = ModalContext.useModalContext();

  const { data } = useQuery<getCustomerBenefits>(getCustomerBenefitsQuery);

  React.useEffect(() => {
    trackLoyaltyModal(
      LoyaltyStatus.activated,
      '/overlay_vip-discount/confirmation/'
    );
  }, []);

  const handleSettingsClick = () => {
    trackEvent({
      eventCategory: 'Service',
      eventAction: 'LoyaltyOverlaySettings',
      eventLabel: undefined,
      eventValue: undefined,
      eventNonInteraction: undefined,
    });
  };

  return (
    <BaseLoyaltyModal
      headerMessage={formatMessage(benefitsModalMessages.header)}
      footerContent={
        <>
          <ButtonWrapper>
            <StyledButton
              buttonSize={ButtonModel.Sizes.medium}
              buttonStyle={ButtonModel.Styles.primary}
              onClick={hideModal}
            >
              <FormattedMessage {...benefitsModalTableMessages.ok} />
            </StyledButton>
          </ButtonWrapper>
          <SettingsWrapper
            href={MY_NOTINO_BENEFIT_PAGE}
            onClick={handleSettingsClick}
          >
            <FormattedMessage {...benefitsModalTableMessages.settings} />
          </SettingsWrapper>
        </>
      }
    >
      <div>
        {data?.customerBenefits && (
          <BenefitsModalContentWrapper>
            <BenefitsModalTable customerBenefits={data.customerBenefits} />
          </BenefitsModalContentWrapper>
        )}
      </div>
    </BaseLoyaltyModal>
  );
};
